<ng-container lcsColumnDef="actions" width="2" autoRegister>
  <th
    lcs-header-cell
    *lcsHeaderCellDef
    [attr.aria-label]="label"
    class="actions-column"
    style="vertical-align: bottom"
    >
    <ng-content></ng-content>
  </th>
  <td lcs-cell *lcsCellDef="let rowData; let index = dataIndex" style="vertical-align: text-top; text-align: end">
    @if (showColumnContent) {
      <button
        type="button"
        mat-icon-button
        [matMenuTriggerFor]="menu"
        [matMenuTriggerData]="{ $implicit: rowData }"
        [attr.aria-label]="label"
        [attr.id]="getId(index, rowData)"
        >
        <mat-icon>more_horiz</mat-icon>
      </button>
    }
  </td>
</ng-container>
